module.exports = __webpack_public_path__ + "img/lying_cat.c30f15d8.png";